// @deprecated - it's easy to create our own layouts and this isn't necessary

import React, { FC, ReactNode } from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { columnSplitToGridSizes } from 'helpers';

const useStyles = makeStyles(theme => ({
  container: {
    [theme.breakpoints.up('lg')]: {
      margin: theme.custom.bodyMargin,
      maxWidth: theme.custom.bodyMaxWidth,
    },
  },
  main: {
    marginTop: theme.custom.mainOffset,
    [theme.breakpoints.between('xs', 'md')]: {
      marginTop: theme.spacing(12),
    },
  },
  gutterBottom: {
    marginBottom: theme.spacing(15),
  },
}));

interface Props {
  sidebar: ReactNode;
  main: ReactNode;
  desktopSplit?: string;
  gutterBottom?: boolean;
}

const App2Column: FC<Props> = props => {
  const { desktopSplit, sidebar, main, gutterBottom } = props;
  const [desktopLeft, desktopMain] = columnSplitToGridSizes(desktopSplit);
  const classes = useStyles();

  return (
    <div className={classNames(classes.container, { [classes.gutterBottom]: gutterBottom })}>
      <Grid container>
        <Grid item xs={12} lg={desktopLeft}>
          {sidebar}
        </Grid>
        <Grid item xs={12} lg={desktopMain} className={classes.main}>
          {main}
        </Grid>
      </Grid>
    </div>
  );
};

App2Column.defaultProps = {
  desktopSplit: '3/9',
};

export default App2Column;
